import { FormRenderer } from "../components/forms/FormRenderer";

export default function FormPreview() {
  let form = null;
  try { form = JSON.parse(localStorage.getItem("bos_form_preview") || "null"); } catch { form = null; }
  if (!form) return <div className="p-10 text-center text-sm text-slate-500" data-testid="form-preview-empty">Open a form in BOS HQ and click "Open preview in new tab".</div>;
  return (
    <div data-testid="form-preview-page">
      <div className="bg-[#0B1220] px-4 py-2 text-center text-xs text-[#EBD6A0]">Preview only - answers aren't saved. To see new changes, click "Open preview in new tab" again in BOS HQ.</div>
      <FormRenderer form={form} preview />
    </div>
  );
}
